module.exports = __webpack_public_path__ + "static/media/moon.e5d4ca66.png";